<template>
  <div class="page">
    <el-container>
      <div class="header-redio">
        <el-radio-group v-model="activeTable" @change="handleRadioChange">
          <el-radio border size="small" :label="3">产品滞销情况</el-radio>
        </el-radio-group>
        <div style="float: right">
          <!-- <el-button type="primary" size="small" @click="onExport"
            >导出</el-button
          > -->
          <el-button class="search-btn iconfont bg-dc-btn" style="top:0" @click="onExport">&#xe60f;&nbsp;导出</el-button>
        </div>
      </div>
      <el-header height="auto">
        <el-form
          :model="formData"
          :inline="true"
          size="mini"
          style="margin-top: 10px"
          label-width="75px"
        >
          <el-form-item label="品类:" class="category">
            <el-select v-model="formData.category" filterable @change="init">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in optionData"
                :label="item.content"
                :key="item.content"
                :value="item.content"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="付款时间:">
            <el-date-picker
                v-model="formData.yearsMonth"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择日期"
            ></el-date-picker>
         </el-form-item> -->
          <el-form-item label="时间选择:">
            <el-select
              v-model="formData.year"
              placeholder="请选择"
              class="yearSelect"
              @change="yearChange"
            >
              <el-option
                v-for="item in timeYear"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="formData.month"
              placeholder="请选择"
              class="yearSelect"
              @change="init"
            >
              <el-option
                v-for="item in timeMonth"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别:">
            <el-select v-model="formData.productType" @change="init">
             <el-option label="全部" value=""></el-option>
             <el-option label="整体" value="整体"></el-option>
             <el-option
                v-for="item in productCategoryData.productType"
                :label="item.content"
                :key="item.content"
                :value="item.content"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="float: right">
            <el-button type="text" style="font-size: 14px" v-if="rihType" @click="detailed">显示明细</el-button>
          </div>
        </el-form>
      </el-header>
      <el-main ref="main">
        <div style="margin-bottom: 5px"></div>
        <el-table
          stripe
          border
          ref="table"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :cell-style="rowCompare"
          highlight-current-row
          :data="tableData"
          :height="tableHeight"
          :span-method="objectSpanMethod"
          v-if="tableHeight && tableReload"
          v-loading="loading"
        >
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :min-width="item.width"
            show-overflow-tooltip
            v-for="item in sortedPropList"
            :key="item.prop"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  item.prop == 'category' ||
                  item.prop == 'typeName' ||
                  !rihType
                "
                >{{ scope.row[item.prop] }}</span
              >
              <span
                :class="`${scope.row.typeName == '整体' ? 'categoryRed' : 'categoryCilck' }`"
                @click="viewSales(scope)"
                v-else
                >{{ scope.row[item.prop] }}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import importExportMxin from "../import&export.mixin";
import customProps from "../customProps.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from "moment";
export default {
  mixins: [importExportMxin, customProps, pagePathMixin],
  props: ["tableHeight"],
  name: "",
  components: {},
  computed: {
    timeYear() {
      let year = moment().year();
      let yearLength = year - 2021;
      let previousYear = year;
      let sumYear = [];
      for (let i = 0; i <= yearLength; i++) {
        sumYear.push({
          value: previousYear - i,
          lable: previousYear - i + "年",
        });
        sumYear.sort(function (a, b) {
          return b.lable - a.lable;
        });
      }
      return sumYear;
    },
    timeMonth() {
      var monthNum = [];
      let setMonth = moment().month()+1
      if(this.formData.year == moment().year()) {
        for (let index = 1; index <= setMonth; index++) {
           monthNum.push(index)
        }
      }else if(this.formData.year == 2021) {
        monthNum = [11, 12]
      }else {
        monthNum = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      }
      let sumMonth = [];
      for (let i = 0; i < monthNum.length; i++) {
        sumMonth.push({
          value: monthNum[i],
          lable: monthNum[i] + "月",
        });
      }
      return sumMonth;
    },
    yearsMonth() {
      let timeYear = this.formData.year
      let timeMonth = this.formData.month
      let yearsMonth = ""
      if(timeMonth < 10) {
        yearsMonth = (timeYear + '') +( '0' + timeMonth)
      }else{
        yearsMonth = (timeYear + '') + timeMonth
      }
      return yearsMonth
    },
    rihType() {
      if (
        this.formData.year == moment().year() &&
        this.formData.month == moment().month() + 1 
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      activeTable: 3,
      loading: false,
      formData: {
        year: moment().year(),
        month: moment().month()+1,
        category: "",
        yearsMonth: ""
      },
      exportData: {},
      tableData: [],
      year: "",
      columnJurisdiction: true,
      tableReload: true,
      optionData: [],
      productCategoryData: [],
    };
  },
  mounted() {
    this.$set(this.formData,'productType', "")
    this.productCategory()
    this.handleRadioChange()
  },
  methods: {
    detailed() {
      this.openSubPage({
        name: "ProductDetails",
        params: {
          category: this.formData.category,
          typeName: this.formData.productType == '整体' ? '' : this.formData.productType
        }
      })
    },
    flitterData(arr) {
      let spanOneArr = [];
      let concatOne = 0;
      if (arr) {
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            if (item.category === arr[index - 1].category) {
              //第一列需合并相同内容的判断条件
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
      } else {
        spanOneArr = [];
      }

      return spanOneArr;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0 && this.activeTable == 3) {
          const _row = this.flitterData(this.tableData)[rowIndex];
          const _col = _row > 0 && _row ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
    },
    yearChange() {
      if(this.formData.year == 2021) {
        this.$set(this.formData,'month',11)
      }else if(this.formData.year == moment().year()) {
        this.$set(this.formData,'month',moment().month()+1)
      }
      this.init()
    },
    init() {
      this.formData.yearsMonth = this.yearsMonth
      this.exportData = this.formData;
      if (this.activeTable == 3) {
        this.getOptions()
        if (!this.formData.year || !this.formData.month) return;
        this.loading = true;
        this.$q.newProduct
          .productUnsoldList({ data: this.formData })
          .then((res) => {
            if (res.data.length && res.code == 200) {
              this.tableData = res.data;
            } else {
              this.tableData = [];
            }
          })
          .finally((_) => {
            this.loading = false;
          });
      }
    },
    viewSales(scope) {
      console.log(scope.row);
      this.openSubPage({
        name: "ProductDetails",
        params: {
          category: scope.row.category,
          categoryType: scope.row.typeName != "整体" ? scope.row.typeName : "",
          unsoldFlag: scope.column.label == "非滞销款数量" ? '0' : scope.column.label == "滞销款数量" ? '1' : "",
          typeName: scope.row.typeName == '整体' ? '' : scope.row.typeName
        }
      })
    },
    getOptions() {
      let params = {
        params: {
          month: this.formData.month,
          year: this.formData.year
        }
      }
      this.$q.newProduct.proOptions(params).then((res) => {
        this.optionData = res.data.category;
      });
    },
    productCategory(){
      this.$q.newProduct.options({}).then((res) => {
        this.productCategoryData = res.data;
      });
    },
    handleRadioChange() {
      //   this.tableHeight = this.$refs["wrapper"].offsetHeight - 5;
      this.propList = this.allPropList;
      this.init();
    },
    rowCompare({ row, column }) {
      // console.log(row);
      // console.log(column);
      if (column.label != "品类" && row.typeName == "整体") {
        return "color: #FF3300";
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.container {
  margin: 5px;
  width: auto;
  height: calc(100% - 20px);
  box-sizing: border-box;
  border-radius: 5px;
}

.header-redio {
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

>>> .el-main {
  padding: 5px 8px 0px 16px;
  background: #ffffff;
  border-radius: 5px;
}

.header-text {
  color: #606266;
  padding: 10px 0px 0 0;
}

>>> ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

>>> .el-table__body-wrapper {
  z-index: 3 !important;
  position: relative !important;
}

>>> .el-form-item {
  margin-bottom: 0;
}

>>> .yearSelect .el-input {
  width: 100px !important;
}

>>> .yearSelect {
  width: 100px !important;
}

>>> .el-tabs--border-card>.el-tabs__header {
  border-radius: 8px;
}

>>> .el-tabs__nav-wrap {
  border-radius: 8px;
}

>>> .category .el-form-item__label {
  width: 45px !important;
}

.bg-dc-btn
    background #FF8900
    border none
    float right !important
    margin-right 4px !important
  .bg-dc-btn:hover
    background-color rgba(255,137,0,.8) !important
  .search-btn
    float left
    height 26px
    line-height 26px
    color #fff
    cursor pointer
    font-size 12px
    padding 0 10px
    margin-right 10px
    position relative
    top 8px
    border-radius 4px
  .search-btn:hover
    background rgba(11,183,142,.8)

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
      margin-bottom: 0;
}

.categoryCilck{
  color: #0BB78E;
  cursor: pointer
}
.categoryRed{
  color: #FF3300;
  cursor: pointer
}
</style>
